import { authedGet, authedWrite } from './apiClient';

export const PEOPLE_MGMT_KEY = 'people-mgmt:v4';

export interface MgmtRow {
  id: number;
  locationCode: string;
  kind: string;
  employeeId: number;
  employeeName: string | null;
  fileNo?: string | null;
  relatedEmployeeId: number | null;
  relatedEmployeeName: string | null;
  relatedFileNo?: string | null;
  amount: string | number | null;
  dateOn: string | null;
  payDate1: string | null;
  payDate2: string | null;
  payDate3: string | null;
  payDate4: string | null;
  linkUrl: string | null;
  notes: string | null;
  hours: string | number | null;
}

export interface PeopleMgmtPayload {
  group: string;
  rows?: MgmtRow[];
  hours?: MgmtRow[];
  raiseAt: number;
}

export function peopleMgmtKey(group: string): string {
  return `${PEOPLE_MGMT_KEY}:${group}`;
}

export function loadPeopleMgmt(group: string): Promise<PeopleMgmtPayload> {
  return authedGet(`/api/v1/people-mgmt?group=${encodeURIComponent(group)}`);
}

export async function addPeopleMgmtRow(body: Record<string, unknown>): Promise<void> {
  await authedWrite('POST', '/api/v1/people-mgmt', body);
}

export async function updatePeopleMgmtRow(id: number, body: Record<string, unknown>): Promise<void> {
  await authedWrite('PATCH', `/api/v1/people-mgmt/${id}`, body);
}

export async function deletePeopleMgmtRow(id: number): Promise<void> {
  await authedWrite('DELETE', `/api/v1/people-mgmt/${id}`, {});
}
